export default {
  props: {
    userType: {
      type: Number,
      default: 1
    },
    basicInfo: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      files: [],
      imgInfo: {}
    };
  },
  watch: {
    basicInfo: {
      handler: function() {
        this.files = this.files.map(item => {
          // 个人用户 户籍资料
          if(item.projectFileType === 'HOUSEHOLD_MATERIALS') {
            let findItem = [];
            this.basicInfo && this.basicInfo.listImg.forEach(child => {
              if(item.projectFileType === child.bizCode) {
                findItem.push(child.allPath);
              }
            });
            return {
              ...item,
              filePaths: findItem ? findItem : []
            };
          } else {
            const fondItem = this.basicInfo && this.basicInfo.listImg.find(itemChild => item.projectFileType === itemChild.bizCode);
            return {
              ...item,
              filePaths: fondItem ? fondItem.allPath : []
            };
          }
        });
        // console.log(this.files, 'this.files');
      }
    }
  },
  mounted() {
    if (this.userType === 1) {
      this.files = [
        {projectFileType: 'ID_CARD_FRONT', title: '身份证个人面', filePaths: []},
        {projectFileType: 'ID_CARD_BACK', title: '身份证国徽面', filePaths: []},
        {projectFileType: 'USER_BANK_CARD', title: '银行卡照片', filePaths: []},
        {projectFileType: 'HOUSEHOLD_MATERIALS', title: '户籍证明材料', filePaths: []}
      ];
    } else if (this.userType === 2) {
      this.files = [
        {projectFileType: 'ID_CARD_FRONT', title: '法定代表人身份证个人面', filePaths: []},
        {projectFileType: 'ID_CARD_BACK', title: '法定代表人身份证国徽面', filePaths: []},
        {projectFileType: 'ASSIGNOR_ID_CARD_FRONT', title: '被授权人身份证个人面', filePaths: []},
        {projectFileType: 'ASSIGNOR_ID_CARD_BACK', title: '被授权人身份证国徽面', filePaths: []},
        {projectFileType: 'LICENSE_IMG', title: '营业执照', filePaths: []},
        {projectFileType: 'CERTIFICATE_IMG', title: '开户许可证', filePaths: []},
        {projectFileType: 'ASSIGNOR_BOOK', title: '授权委托书', filePaths: []}
      ];
    } else if (this.userType === 3) {
      this.files = [
        {projectFileType: 'ID_CARD_FRONT', title: '法定代表人身份证个人面', filePaths: []},
        {projectFileType: 'ID_CARD_BACK', title: '法定代表人身份证国徽面', filePaths: []},
        {projectFileType: 'ASSIGNOR_ID_CARD_FRONT', title: '被授权人身份证个人面', filePaths: []},
        {projectFileType: 'ASSIGNOR_ID_CARD_BACK', title: '被授权人身份证国徽面', filePaths: []},
        {projectFileType: 'LICENSE_IMG', title: '农村集体经济组织登记证', filePaths: []},
        {projectFileType: 'CERTIFICATE_IMG', title: '开户许可证', filePaths: []},
        {projectFileType: 'ASSIGNOR_BOOK', title: '授权委托书', filePaths: []}
      ];
    }
  }
};
